import { C } from '../utils/constants';

export const DayCard = ({ day, progressData, isUnlocked, onClick }) => {
  const isComplete = progressData?.day_complete || false;
  const isLocked = !isUnlocked;

  const getStatusText = () => {
    if (isComplete) return 'Complete ✓';
    if (isLocked) return `Opens when Day ${day.num - 1} is complete`;
    if (progressData?.video_complete) return 'Journal pending';
    if (progressData?.video_progress > 0) return `Video ${progressData.video_progress}% watched`;
    return 'Ready to start';
  };

  const getCircleContent = () => {
    if (isComplete) return { icon: '★', bg: `linear-gradient(135deg, ${C.amber}, ${C.gold})`, color: '#fff' };
    if (isLocked) return { icon: '🔒', bg: C.veryLightBrown, color: C.terracotta };
    return { icon: String(day.num), bg: `linear-gradient(135deg, ${C.brown}, ${C.amber})`, color: '#fff' };
  };

  const circle = getCircleContent();

  return (
    <div
      onClick={isUnlocked ? onClick : undefined}
      style={{
        background: '#fff',
        border: `2.5px solid ${isComplete ? C.gold : isLocked ? C.border : C.gold}`,
        borderRadius: 12,
        padding: '18px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        cursor: isUnlocked ? 'pointer' : 'default',
        opacity: isLocked ? 0.75 : 1,
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        boxShadow: isComplete
          ? `0 2px 12px rgba(245,166,35,0.2)`
          : '0 1px 4px rgba(0,0,0,0.06)',
      }}
      onMouseEnter={e => {
        if (isUnlocked) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 24px rgba(107,62,10,0.15)';
        }
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = isComplete
          ? '0 2px 12px rgba(245,166,35,0.2)'
          : '0 1px 4px rgba(0,0,0,0.06)';
      }}
    >
      {/* Circle icon */}
      <div style={{
        width: 48,
        height: 48,
        borderRadius: '50%',
        background: circle.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: isComplete ? '1.3rem' : isLocked ? '1.1rem' : '1.1rem',
        color: circle.color,
        fontFamily: "'Forum', serif",
        fontWeight: 700,
        flexShrink: 0,
        boxShadow: isComplete ? `0 0 12px rgba(245,166,35,0.4)` : 'none',
      }}>
        {circle.icon}
      </div>

      {/* Center info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: "'Forum', serif",
          fontSize: '0.8rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: C.terracotta,
          marginBottom: 3,
        }}>
          Day {day.num}
        </div>
        <div style={{
          fontFamily: "'Forum', serif",
          fontSize: '1.15rem',
          color: isLocked ? C.terracotta : C.brown,
          marginBottom: 8,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {day.title}
        </div>

        {/* Tags */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <Tag label="Video" active={progressData?.video_complete} />
          <Tag label="Journal" active={progressData?.journal_complete} />
          {day.hasMeditation && <Tag label="Meditation" active={progressData?.meditation_complete} />}
        </div>
      </div>

      {/* Status text */}
      <div style={{
        fontSize: '0.88rem',
        color: isComplete ? C.amber : isLocked ? C.terracotta : C.brown,
        fontWeight: isComplete ? 700 : 400,
        textAlign: 'right',
        flexShrink: 0,
        maxWidth: 120,
      }}>
        {getStatusText()}
      </div>
    </div>
  );
};

const Tag = ({ label, active }) => (
  <span style={{
    fontSize: '0.68rem',
    padding: '2px 8px',
    borderRadius: 20,
    background: active ? 'rgba(245,166,35,0.15)' : 'rgba(232,213,196,0.4)',
    color: active ? C.amber : C.terracotta,
    fontWeight: active ? 700 : 400,
    border: active ? `1px solid rgba(245,166,35,0.3)` : `1px solid ${C.border}`,
    letterSpacing: '0.03em',
  }}>
    {label}
  </span>
);

